import React, { useContext, useEffect, useState } from 'react';
import { Box, Typography, Paper, Button, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import jsPDF from 'jspdf';
import axios from 'axios';
import { ReportContext } from '../../Context';
// Images Salduz par type/langue
import s3fr1 from '../../../assets/salduz/s3/fr/1.jpg';
import s3fr2 from '../../../assets/salduz/s3/fr/2.jpg';
import s3nl1 from '../../../assets/salduz/s3/nl/1.jpg';
import s3nl2 from '../../../assets/salduz/s3/nl/2.jpg';
import s3de1 from '../../../assets/salduz/s3/de/1.jpg';
import s3de2 from '../../../assets/salduz/s3/de/2.jpg';
import s3en1 from '../../../assets/salduz/s3/en/1.jpg';
import s3en2 from '../../../assets/salduz/s3/en/2.jpg';
import s4fr1 from '../../../assets/salduz/s4/fr/1.jpg';
import s4fr2 from '../../../assets/salduz/s4/fr/2.jpg';
import s4fr3 from '../../../assets/salduz/s4/fr/3.jpg';
import s4fr4 from '../../../assets/salduz/s4/fr/4.jpg';
import s4nl1 from '../../../assets/salduz/s4/nl/1.jpg';
import s4nl2 from '../../../assets/salduz/s4/nl/2.jpg';
import s4nl3 from '../../../assets/salduz/s4/nl/3.jpg';
import s4nl4 from '../../../assets/salduz/s4/nl/4.jpg';
import s4de1 from '../../../assets/salduz/s4/de/1.jpg';
import s4de2 from '../../../assets/salduz/s4/de/2.jpg';
import s4de3 from '../../../assets/salduz/s4/de/3.jpg';
import s4de4 from '../../../assets/salduz/s4/de/4.jpg';
import s4en1 from '../../../assets/salduz/s4/en/1.jpg';
import s4en2 from '../../../assets/salduz/s4/en/2.jpg';
import s4en3 from '../../../assets/salduz/s4/en/3.jpg';
import s4en4 from '../../../assets/salduz/s4/en/4.jpg';
import s4mdtfr1 from '../../../assets/salduz/s4mdt/fr/1.jpg';
import s4mdtfr2 from '../../../assets/salduz/s4mdt/fr/2.jpg';
import s4mdtfr3 from '../../../assets/salduz/s4mdt/fr/3.jpg';
import s4mdtfr4 from '../../../assets/salduz/s4mdt/fr/4.jpg';
import s4mdtnl1 from '../../../assets/salduz/s4mdt/nl/1.jpg';
import s4mdtnl2 from '../../../assets/salduz/s4mdt/nl/2.jpg';
import s4mdtnl3 from '../../../assets/salduz/s4mdt/nl/3.jpg';
import s4mdtnl4 from '../../../assets/salduz/s4mdt/nl/4.jpg';
import s4mdtde1 from '../../../assets/salduz/s4mdt/de/1.jpg';
import s4mdtde2 from '../../../assets/salduz/s4mdt/de/2.jpg';
import s4mdtde3 from '../../../assets/salduz/s4mdt/de/3.jpg';
import s4mdtde4 from '../../../assets/salduz/s4mdt/de/4.jpg';
import s4mdten1 from '../../../assets/salduz/s4mdt/en/1.jpg';
import s4mdten2 from '../../../assets/salduz/s4mdt/en/2.jpg';
import s4mdten3 from '../../../assets/salduz/s4mdt/en/3.jpg';
import s4mdten4 from '../../../assets/salduz/s4mdt/en/4.jpg';

function Rights() {
  const { report } = useContext(ReportContext);
  const [settings, setSettings] = useState(null);
  const [reportData, setReportData] = useState(null);
  const [downloading, setDownloading] = useState(false);
  const [loading, setLoading] = useState(true);
  const [rightsType, setRightsType] = useState('');
  const [language, setLanguage] = useState('');

  const rightsOptions = [
    { value: 's3', label: 'Personne NON privée de liberté' },
    { value: 's4', label: 'Personne privée de liberté' },
    { value: 's4mdt', label: "Personne privée de liberté sur base d'un mandat" }
  ];

  const languageOptions = [
    { value: 'fr', label: 'Français' },
    { value: 'nl', label: 'Néerlandais' },
    { value: 'de', label: 'Allemand' },
    { value: 'en', label: 'Anglais' },
  ];

  const imageSets = {
    s3: {
      fr: [s3fr1, s3fr2],
      nl: [s3nl1, s3nl2],
      de: [s3de1, s3de2],
      en: [s3en1, s3en2],
    },
    s4: {
      fr: [s4fr1, s4fr2, s4fr3, s4fr4],
      nl: [s4nl1, s4nl2, s4nl3, s4nl4],
      de: [s4de1, s4de2, s4de3, s4de4],
      en: [s4en1, s4en2, s4en3, s4en4],
    },
    s4mdt: {
      fr: [s4mdtfr1, s4mdtfr2, s4mdtfr3, s4mdtfr4],
      nl: [s4mdtnl1, s4mdtnl2, s4mdtnl3, s4mdtnl4],
      de: [s4mdtde1, s4mdtde2, s4mdtde3, s4mdtde4],
      en: [s4mdten1, s4mdten2, s4mdten3, s4mdten4],
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = sessionStorage.getItem('authToken');

        const settingsResponse = await axios.get('/api/settings', {
          headers: token ? { Authorization: `Bearer ${token}` } : undefined
        });
        setSettings(settingsResponse.data);

        if (report?.number && report?.year) {
          const reportResponse = await axios.get(
            `/api/report/search?number=${report.number}&year=${report.year}`,
            { headers: { Authorization: `Bearer ${token}` } }
          );
          setReportData(reportResponse.data);
        }
        setLoading(false);
      } catch (error) {
        console.error('Erreur lors du chargement des données pour le PDF Salduz :', error);
        setLoading(false);
      }
    };

    fetchData();
  }, [report]);

  const svgTextToPngBase64 = (svgText, width = 150, height = 150) => {
    return new Promise((resolve, reject) => {
      const img = new Image();

      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');

        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, width, height);
        ctx.drawImage(img, 0, 0, width, height);
        const base64 = canvas.toDataURL('image/png').split(',')[1];
        resolve(base64);
      };

      img.onerror = reject;

      const svgBlob = new Blob([svgText], { type: 'image/svg+xml;charset=utf-8' });
      const url = URL.createObjectURL(svgBlob);
      img.src = url;
    });
  };

  const loadLogoDataUrl = async () => {
    const svgContent = `<?xml version="1.0" encoding="utf-8"?>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 150" width="150" height="150">
  <circle cx="75" cy="75" r="74" fill="#FFFFFF" stroke="#244BA6" stroke-width="2"/>
  <path fill="#244BA6" d="M150,75c0-41.4-33.6-75-75-75S0,33.6,0,75c0,39.5,30.5,71.9,69.3,74.8c-3.3-4-7.4-9.5-11-14.6
    c-6.1-8.6-13.4-21.5-13.7-34.4c-0.2-9.6,2-14.8,14.6-34.7c4.9-7.8,8.2-21.1,7.7-23.9c-0.5-2.9,4.6,4.3,6.5,9.1
    c2.5,6.4,2.2,11.2-2.5,24.4c-2.2,6.3-5.9,16.4-2.2,20.9c-0.4-0.5,11.9-13.2,14.8-26.2c2.2-10,1.3-23.3-3-33.1
    c-3.8-8.6-8.3-15.7-7.4-27.1c0.4-4.8,1.7-9.4,1.8-9.7c2.8,7,4,9.5,5.1,11.5c5.1,9.6,15.6,23.7,20.5,33.4
    c5,9.6,8.8,25.5,3,41.7c-5.7,15.9-11.1,21.3-16.9,34.2c-4.3,9.6-7.9,21.4-9.7,28.8C117.5,149,150,115.9,150,75"/>
</svg>`;

    try {
      const base64 = await svgTextToPngBase64(svgContent, 100, 100);
      return `data:image/png;base64,${base64}`;
    } catch (error) {
      console.warn('Erreur conversion logo:', error);
      return null;
    }
  };

  const buildReportNumber = () => {
    if (!reportData || !settings) return 'XXXXXX';

    const shortJudicialDistrict = settings.shortJudicialDistrict || '__';
    const indice = reportData.indice || '__';
    const judicialDivision = settings.judicialDivision || '__';
    const number = report?.number || '__';
    const year = report?.year || '__';

    return `${shortJudicialDistrict}.${indice}.${judicialDivision}.${number}/${year}`;
  };

  const fetchAssetAsDataUrl = async (assetUrl) => {
    const response = await fetch(assetUrl);
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };

  const getImageDimensions = (dataUrl) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve({ width: img.width, height: img.height });
      img.onerror = reject;
      img.src = dataUrl;
    });
  };

  const handleDownload = async (typeKey, langKey) => {
    if (!settings || !reportData) {
      console.error('Impossible de générer le PDF : paramètres ou données du PV manquants.');
      return;
    }

    const selectedImagesPaths = imageSets[typeKey]?.[langKey] || [];
    if (selectedImagesPaths.length === 0) {
      console.error('Aucune image correspondante au type/langue sélectionnés.', { typeKey, langKey });
      return;
    }

    setDownloading(true);

    try {
      const [logoDataUrl, ...images] = await Promise.all([
        loadLogoDataUrl(),
        ...selectedImagesPaths.map(fetchAssetAsDataUrl)
      ]);

      const doc = new jsPDF({
        orientation: 'p',
        unit: 'mm',
        format: 'a4',
      });

      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const margin = 15;
      const headerHeight = 26;
      const typeValue =
        settings?.type === 'local'
          ? 'Locale'
          : settings?.type === 'federal'
          ? 'Fédérale'
          : settings?.type || 'N/A';
      const reportNumber = buildReportNumber();
      const reportType =
        reportData?.reportType === 'subsequent'
          ? 'subséquent'
          : reportData?.reportType || '';

      const drawHeader = () => {
        const leftX = margin;
        const midX = margin + 20;
        const rightX = pageWidth - margin;

        if (logoDataUrl) {
          doc.addImage(logoDataUrl, 'PNG', leftX, 9.5, 12, 12);
        }

        doc.setFont('helvetica', 'normal');
        doc.setFontSize(9);
        doc.text(`Police ${typeValue}`, midX, 12);

        doc.setFont('helvetica', 'bold');
        doc.text(`${settings?.clientName || 'N/A'} - ${settings?.zoneNumber || 'N/A'}`, midX, 16.5);

        doc.setFont('helvetica', 'normal');
        doc.text(`Service ${reportData?.unit || ''}`, midX, 21);

        doc.text(`Procès-verbal ${reportType}`, rightX, 12, { align: 'right' });
        doc.setFont('helvetica', 'bold');
        doc.text(reportNumber, rightX, 16.5, { align: 'right' });
        doc.setFont('helvetica', 'normal');
        doc.text('Annexe n° _____', rightX, 21, { align: 'right' });

        doc.setLineWidth(0.5);
        doc.line(margin, 25, pageWidth - margin, 25);
      };

      const addImagePage = async (dataUrl, isFirstPage) => {
        if (!isFirstPage) {
          doc.addPage();
        }

        drawHeader();
        const { width, height } = await getImageDimensions(dataUrl);
        const maxWidth = pageWidth - margin * 2;
        const maxHeight = pageHeight - headerHeight - margin;
        const ratio = Math.min(maxWidth / width, maxHeight / height);
        const renderWidth = width * ratio;
        const renderHeight = height * ratio;
        const x = (pageWidth - renderWidth) / 2;
        const y = headerHeight;

        doc.addImage(dataUrl, 'JPEG', x, y, renderWidth, renderHeight);
      };

      // Première page sans addPage
      if (images[0]) {
        await addImagePage(images[0], true);
      }
      for (let i = 1; i < images.length; i++) {
        await addImagePage(images[i], false);
      }

      doc.save(`droits-salduz-${typeKey}-${langKey}.pdf`);

      // Log du téléchargement
      try {
        const token = sessionStorage.getItem('authToken');
        const typeLabel = rightsOptions.find(opt => opt.value === typeKey)?.label || typeKey;
        const langLabel = languageOptions.find(opt => opt.value === langKey)?.label || langKey;
        
        await axios.post('/api/appendices/log-download', {
          appendixType: 'Rights',
          appendixTitle: 'Droits Salduz',
          reportNumber: `${report?.number}/${report?.year}`,
          formData: {
            typeDroits: typeLabel,
            typeDroitsCode: typeKey,
            langue: langLabel,
            langueCode: langKey
          }
        }, {
          headers: { Authorization: `Bearer ${token}` }
        });
      } catch (logError) {
        console.warn('Erreur lors du log du téléchargement:', logError);
        // Ne pas bloquer le téléchargement en cas d'erreur de log
      }
    } catch (error) {
      console.error('Erreur lors de la génération du PDF Salduz :', error);
    } finally {
      setDownloading(false);
    }
  };

  return (
    <Box sx={{ p: 0 }}>
      <Paper sx={{ p: 2 }}>
        <Typography variant="h6" gutterBottom>
          Droits Salduz
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Complétez les informations ci-dessous pour générer les droits Salduz.
        </Typography>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <FormControl fullWidth>
            <InputLabel id="rights-type-label">Type de droits</InputLabel>
            <Select
              labelId="rights-type-label"
              value={rightsType}
              label="Type de droits"
              onChange={(e) => {
                setRightsType(e.target.value);
              }}
            >
              {rightsOptions.map((opt) => (
                <MenuItem key={opt.value} value={opt.value}>
                  {opt.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl fullWidth>
            <InputLabel id="rights-language-label">Langue</InputLabel>
            <Select
              labelId="rights-language-label"
              value={language}
              label="Langue"
              onChange={(e) => setLanguage(e.target.value)}
            >
              {languageOptions.map((opt) => (
                <MenuItem key={opt.value} value={opt.value}>
                  {opt.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {rightsType && language && (
            <Button
              variant="contained"
              color="primary"
              startIcon={<PictureAsPdfIcon />}
              onClick={() => handleDownload(rightsType, language)}
              disabled={downloading || loading || !settings || !reportData}
            >
              {downloading ? 'Préparation…' : 'Télécharger le PDF'}
            </Button>
          )}
        </Box>
      </Paper>
    </Box>
  );
}

export default Rights;
